<template>
  <a-modal
    class="modal-content"
    :title="title"
    :width="870"
    :visible="visible"
    ok-text="保存"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <template>
      <a-form-model
        ref="ruleForm"
        :labelCol="{ span: 3 }"
        :wrapperCol="{ span: 20 }"
        :model="form"
        :rules="rules"
      >
        <a-form-model-item label="标题" prop="title">
          <a-input v-model="form.title" placeholder="请输入标题" />
        </a-form-model-item>
        <a-form-model-item label="选择分类" prop="classify">
          <j-dict-select-tag
            placeholder="请选择分类"
            v-model="form.classify"
            :dictCode="cateDictCode"
            allowClear
          />
        </a-form-model-item>
        <a-form-model-item label="上传封面" prop="file">
          <div class="flex-align-center">
            <JImageUpload ref="coverRef" bizPath="resourceCource" />
            <span style="color: #cdcdcd">*建议封面尺寸444 * 252，大小不超过500kb</span>
          </div>
        </a-form-model-item>
        <a-form-model-item label="详细介绍" prop="content">
          <WangEditor
            v-model="form.content"
            :editorStyle="{ minHeight: '200px' }"
            style="margin: 2px; border: 1px solid #d9d9d9; border-radius: 4px; overflow: hidden"
          />
        </a-form-model-item>
      </a-form-model>
    </template>
  </a-modal>
</template>

<script>
import WangEditor from '@/components/WangEditor'
import JImageUpload from '@/components/jeecg/JImageUpload'
import JUpload from '@/components/jeecg/JUpload'
import { postAction, putAction } from '@/api/manage'

export default {
  name: 'CulturalModal',
  components: {
    WangEditor,
    JImageUpload,
    JUpload,
  },
  props: {
    title: {
      type: String,
      default: '创建',
    },
    activeKey: {
      type: [String, Number],
      default: undefined,
    },
    cateDictCode: {
      type: String,
      default: 'course_sort',
    },
    bizPath: {
      type: String,
      default: 'resourceCource',
    },
    actionUrl: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      visible: false,
      current: 1,
      labelCol: { span: 3 },
      wrapperCol: { span: 20 },
      itemLabelCol: { span: 5 },
      itemWrapperCol: { span: 18 },
      form: {},
      rules: {
        title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        classify: [{ required: true, message: '请选择分类', trigger: 'blur' }],
      },
      currEvalInfo: {},
    }
  },
  methods: {
    showModal(data) {
      this.visible = true
      if (!data) return
      this.form = {
        id: data.id,
        title: data.title,
        classify: data.classify,
        // cover: data.cover,
        content: data.content,
      }
    },
    hideModal() {
      this.visible = false
      this.current = 1
      this.form = {}
    },
    handleOk() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (!valid) return
        const cover = this.$refs['coverRef'].fileList.map((file) => {
          return { name: file.oldName, pic: file.response.message }
        })

        // const res = this.form.id
        //   ? await putAction('/resourceCultural/edit', this.form)
        //   : await postAction('/resourceCultural/add', this.form)
        const params = { cover: cover?.[0]?.pic, ...this.form, type: this.activeKey }
        console.log('参数信息：', params)
        const actionUrl = this.actionUrl.replace('/', '')
        const res = this.form.id
          ? await putAction(`/${actionUrl || this.bizPath}/edit`, params)
          : await postAction(`/${actionUrl || this.bizPath}/add`, params)
        console.log('创建：', res)
        if (res.success) {
          this.$message.success(res.message)
          this.$emit('refreshData')
        } else {
          this.$message.error(res.message)
        }
        this.hideModal()
      })
    },
    handleCancel() {
      this.hideModal()
    },
  },
}
</script>
<style scoped lang="less">
.modal-content {
  /deep/ .ant-upload-picture-card-wrapper {
    width: auto;
  }
}
</style>
